import { createUserManager } from 'redux-oidc';
import { UserManager, UserManagerSettings } from 'oidc-client';
import { AppConfig } from '../appConfig';

/* eslint-disable @typescript-eslint/camelcase */
const getUserManagerConfig = (appConfig: AppConfig): UserManagerSettings => {
  const baseUrl = appConfig?.REACT_APP_BASE_URL || '/';
  return {
    authority: process.env.NO_OIDC
      ? 'http://localhost'
      : appConfig?.REACT_APP_AUTHORITY || 'https://vmsserver.erecruit.com',
    client_id: 'vms-client',
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? `:${window.location.port}` : ''
    }${baseUrl}auth/callback`,
    response_type: 'code',
    scope: 'openid profile erecruit vms',
    silent_redirect_uri: `${window.location.protocol}//${
      window.location.hostname
    }${
      window.location.port ? `:${window.location.port}` : ''
    }${baseUrl}silent_renew.html`,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    post_logout_redirect_uri: `${window.location.protocol}//${
      window.location.hostname
    }${window.location.port ? `:${window.location.port}` : ''}`,
  };
};

let userManager: UserManager | undefined = undefined;

const getUserManager = () => {
  if (!userManager) throw new Error('User manager not initialized');
  return userManager;
};

export const initializeUserManager = (appConfig: AppConfig) => {
  if (!userManager) {
    const userManagerConfig = getUserManagerConfig(appConfig);
    userManager = createUserManager(userManagerConfig);
  }
};

export default getUserManager;
